$(document).ready(function()
{
    // mostly thi has been moved to multi-map.js


    // all this is does hide sub-foilter buttons if they're empty.
    if ($('.sub-filter-button').length)
    {
    	var active_sub_cats = [];

        $( "#all-listings .card" ).each(function( i ) 
        {
        	var classList = $(this).attr("class").split(/\s+/);
			$.each(classList, function(index, item) {
			    if (item != 'card' && item != 'do-show' && item != 'active' && item != 'inactive') 
			    {
			    	if (active_sub_cats.indexOf(item) < 0)
			    	{
			      		active_sub_cats.push(item);
			      	}
			    }
			});

			
        });
        // that's now a list of all sub cats in use on the page
        //console.log(active_sub_cats);
        // so go through and make inactive buttons 
		$( ".sub-filter-button" ).each(function( i ) 
		{
			var the_slug = $(this).data('subcategory');
			if (active_sub_cats.indexOf(the_slug) < 0)
			{
				$(this).addClass('inactive');
			}
		});        

    }

});